import {
  get,
} from 'lodash';
import { passwordManagerItemScope } from 'client/PasswordManager/PasswordManagerConstants';
import CollectionModule from 'client/store/modules/CollectionModule';
import PasswordManagerItemApi from 'client/api/v2/PasswordManagerItemApi';
import Vue from 'vue';

export const PasswordManagerItemCollection = (Api = PasswordManagerItemApi) => {
  const collection = new CollectionModule(Api, 'id', 'nickname');
  const PasswordManagerItemCollectionModule = collection.extractModule();

  const UPDATE_REFRESH_KEY = 'UPDATE_REFRESH_KEY';
  const SET_PASSWORD_MANAGER_ITEMS_SCOPE = 'SET_PASSWORD_MANAGER_ITEMS_SCOPE';
  const SET_PASSWORD_MANAGER_ITEMS_COUNTS = 'SET_PASSWORD_MANAGER_ITEMS_COUNTS';
  const RESET_PASSWORD_MANAGER_ITEMS = 'RESET_PASSWORD_MANAGER_ITEMS';

  const getInitialState = () => {
    const { state } = PasswordManagerItemCollectionModule;
    state.allItemsCounts = [];
    state.refreshKey = 0;
    state.scope = {
      scopeType: '',
      scopeId: '',
    };
    return state;
  };

  return {
    namespaced: true,

    state: getInitialState(),

    actions: {
      ...PasswordManagerItemCollectionModule.actions,

      async fetchCollection(context, { next = false } = {}) {
        let { skip } = context.state.features.items.pagination;
        const { sort, searchTerm } = context.state.features.items;
        const {
          skipToken,
          nextPageToken,
          limit,
        } = context.state.features.items.pagination;
        const filters = context.getters.getFilters;

        if (next === true && !nextPageToken && !skipToken) {
          if (collection.Api.usesPageTokens || collection.Api.usesSkipTokens) {
            return false;
          }

          skip += limit;

          if (skip >= context.state.entities.items.totalCount) {
            return false;
          }

          context.commit('SET_PAGINATION_SKIP', { skip });
        }

        const items = await collection.fetchWrapper(context, skip, limit, sort, searchTerm,
          filters, nextPageToken, skipToken);

        const payload = {
          results: items.results,
          totalCount: items.totalCount,
          nextPageToken: items.nextPageToken,
          skipToken: items.skipToken,
        };

        if (context.state.entities.items.totalCountOfAllItems === null) {
          payload.totalCountOfAllItems = items.totalCount;
        }

        context.commit('SET_COLLECTION', payload);
        context.commit(SET_PASSWORD_MANAGER_ITEMS_COUNTS, items.items);

        return items.results.map(result => get(result, collection.idField));
      },

      updateRefreshKey(context) {
        context.commit(UPDATE_REFRESH_KEY);
      },

      resetPasswordManagerItems({ commit }) {
        Api.setBaseUrl('/api/v2/passwordmanager/items');

        commit(RESET_PASSWORD_MANAGER_ITEMS);
        commit('RESET_COLLECTION');
      },

      setPasswordManagerItemsScope({ commit }, scope) {
        commit(SET_PASSWORD_MANAGER_ITEMS_SCOPE, scope);

        if (!scope || !scope.scopeType || scope.scopeType === passwordManagerItemScope.none) {
          Api.setBaseUrl('/api/v2/passwordmanager/items');
        } else if (scope.scopeType === passwordManagerItemScope.user) {
          Api.setBaseUrl(`/api/v2/passwordmanager/users/${scope.scopeId}/items`);
        }
      },
    },

    getters: {
      ...PasswordManagerItemCollectionModule.getters,

      allItemsCounts(state) {
        return state.allItemsCounts;
      },

      refreshKey(state) {
        return state.refreshKey;
      },

      scope(state) {
        return state.scope;
      },
    },

    mutations: {
      ...PasswordManagerItemCollectionModule.mutations,

      [SET_PASSWORD_MANAGER_ITEMS_COUNTS](state, allItemsCounts) {
        Vue.set(state, 'allItemsCounts', allItemsCounts);
      },

      [SET_PASSWORD_MANAGER_ITEMS_SCOPE](state, scope) {
        Vue.set(state, 'scope', scope);
      },

      [RESET_PASSWORD_MANAGER_ITEMS](state) {
        const initialState = getInitialState();

        Vue.set(state, 'refreshKey', initialState.refreshKey);
        Vue.set(state, 'scope', initialState.scope);
      },

      [UPDATE_REFRESH_KEY](state) {
        Vue.set(state, 'refreshKey', state.refreshKey + 1);
      },
    },
  };
};

export default PasswordManagerItemCollection();
